import { postRequest, } from "../../utils/api"

export const apiListFeedbacks = (data, pageData) => {
   return postRequest('/api/feedback/list', data, pageData)
}